exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-page .error-container {\n  margin: 0 auto;\n  padding: 192px 96px;\n  text-align: center;\n}\n.error-page .error-container img {\n  width: 916px;\n  height: auto;\n  margin-bottom: 16px;\n}\n.error-page .error-container h1 {\n  font-size: 48px;\n  color: #FF4E35;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n", ""]);

// exports
